module.exports = __webpack_public_path__ + "assets/45cf840ba3d7b56bb4bc9eeac879a01b.png";